import React, {Component} from 'react'
// import {Storage} from './../storage/storage'
import Board from './Board'

// https://blog.alexdevero.com/how-to-build-simple-tic-tac-toe-game-with-react/

// https://github.com/kelanwu/react-tic-tac-toe/blob/master/src/index.js


class Game extends Component {
 

    render(){
        return(

            <Board />        

        )
    }
}

export default Game;
